import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { UpdatePole } from '../editPole/updatePole';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/roles/roleDetailsHeader.css';

const PoleDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/poles');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const poleDetailsData = useSelector((state) => state.PoleDetailsData);

    const hasPoleUpdatePermission = useHasPermission('pole_update');
    const hasPoleDeletePermission = useHasPermission('pole_delete');

    const [errMsg, setErrMsg] = useState('');
    const [updatePoleOpen, setUpdatePoleOpen] = useState(false);
    const [deletePoleOpen, setDeletePoleOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDeletePole = async () => {
        try {
            const response = await axios.delete(`pole/${poleDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeletePoleOpen(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression du pôle");
            console.error('Error deleting pole:', error);
            CustomErrorLogger(error, "Delete pole in PoleDetailsHeader");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="roleDetailsHeader_mainBox">
            <Box className="roleDetailsHeader_firstPart">
                <Iconify className='roleDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="roleDetailsHeader_title">{poleDetailsData?.name}</Typography>
                {hasPoleUpdatePermission && <Iconify className='roleDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setUpdatePoleOpen(true)} />}
                {poleDetailsData?.description}
            </Box>
            <Box className="roleDetailsHeader_secondPart">
                {isDesktop && hasPoleDeletePermission &&
                    <Box className="roleDetailsHeader_action_box" onClick={() => setDeletePoleOpen(true)}>
                        <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='roleDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasPoleDeletePermission &&
                        <MenuItem className='roleDetailsHeader_menuItem' onClick={() => setDeletePoleOpen(true)}>
                            <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {updatePoleOpen &&
                <UpdatePole
                    updatePoleOpen={updatePoleOpen}
                    setUpdatePoleOpen={setUpdatePoleOpen}
                />
            }

            {deletePoleOpen &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deletePoleOpen}
                    setOpenDelete={setDeletePoleOpen}
                    handleDelete={handleDeletePole}
                    title="Êtes-vous sûr de vouloir supprimer ce pôle ?"
                />
            }
        </Box>
    );
}

export default PoleDetailsHeader;